/**
 * @fileoverview Custom analysis modal with alternative footer layout
 */

import React from 'react';
import TrebbleSpace from '../../common/TrebbleSpace.tsx';
import TrebbleModal from '../../common/TrebbleModal.tsx';
import TrebbleButton from '../../common/TrebbleButton.tsx';
import AnalysisWizardContent from './AnalysisWizardContent.jsx';
// @ts-ignore
import ti18n from 'i18n!nls/Deepcuti18n';

/**
 * @typedef {import('../types/deepcut.js').AnalysisResults} AnalysisResults
 * @typedef {import('../types/deepcut.js').UserFeedback} UserFeedback
 */

/**
 * Custom analysis modal with alternative footer layout
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the modal is open
 * @param {AnalysisResults|null} props.results - Analysis results
 * @param {string} props.transcript - The transcript text
 * @param {number|null} props.transcriptId - ID of the transcript (if saved)
 * @param {Function} props.onClose - Callback for closing the modal
 * @param {Function} props.onApply - Callback for applying the final plan
 * @param {boolean} [props.isUpdating] - Whether plan is being updated
 * @param {boolean} [props.isLoading] - Whether analysis is loading
 * @returns {React.ReactElement}
 */
export default function CustomAnalysisModal({
  open,
  results,
  transcript,
  transcriptId,
  onClose,
  onApply,
  isUpdating = false,
  isLoading = false
}) {
  return (
    <TrebbleModal
      title={window.getI18n(ti18n, 'CUSTOM_ANALYSIS')}
      open={open}
      onCancel={onClose}
      width={800}
      centered
      footer={null}
      className="custom-analysis-modal"
    >
      <AnalysisWizardContent
        results={results}
        transcript={transcript}
        transcriptId={transcriptId}
        onClose={onClose}
        onApply={onApply}
        isUpdating={isUpdating}
        isLoading={isLoading}
        renderFooter={(footerProps) => (
          <div style={{ 
            borderTop: '1px solid #f0f0f0', 
            padding: '16px 0 0 0',
            marginTop: '24px'
          }}>
            <TrebbleSpace style={{ width: '100%', justifyContent: 'flex-end' }}>
              <TrebbleButton onClick={footerProps.onClose}>
                {window.getI18n(ti18n, 'CANCEL')}
              </TrebbleButton>
              <TrebbleButton onClick={footerProps.onBack} disabled={footerProps.currentStep === 'goal'}>
                {window.getI18n(ti18n, 'BACK')}
              </TrebbleButton>
              {footerProps.currentStep === 'plan' ? (
                <TrebbleButton 
                  type="primary" 
                  onClick={footerProps.onApply}
                  loading={footerProps.isUpdating}
                >
                  {window.getI18n(ti18n, 'APPLY')}
                </TrebbleButton>
              ) : (
                <TrebbleButton 
                  type="primary"
                  onClick={footerProps.onNext}
                  disabled={!footerProps.canProceed || footerProps.isRefreshing}
                  loading={footerProps.isRefreshing}
                >
                  {window.getI18n(ti18n, 'CONTINUE')}
                </TrebbleButton>
              )}
            </TrebbleSpace>
          </div>
        )}
      />
    </TrebbleModal>
  );
} 